import { render, staticRenderFns } from "./ClusterSummaryCardBasic.vue?vue&type=template&id=941bc894&scoped=true&"
import script from "./ClusterSummaryCardBasic.vue?vue&type=script&setup=true&lang=js&"
export * from "./ClusterSummaryCardBasic.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ClusterSummaryCardBasic.vue?vue&type=style&index=0&id=941bc894&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941bc894",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VExpandTransition,VIcon,VSpacer,VTextarea})
